import { contextKeys } from '../types/initDataTypes.js';

function composeParameter(parameterStore, initData, keyWrapper = (key) => key) {
    contextKeys.forEach((key) => {
        const keyAsInitDataKey = key;
        if (initData[keyAsInitDataKey]) {
            parameterStore.append(keyWrapper(key), initData[keyAsInitDataKey]);
        }
    });
}
function composeHeaderParameter(initData) {
    const headerStore = new Headers();
    initData.gandalfToken &&
        headerStore.append('Authorization', `Bearer ${initData.gandalfToken}`);
    composeParameter(headerStore, initData, (rawHeader) => `x-${rawHeader}`);
    return headerStore;
}
function composeQueryParameter(initData) {
    const searchParameter = new URLSearchParams();
    composeParameter(searchParameter, initData);
    return searchParameter.toString();
}

export { composeHeaderParameter, composeQueryParameter };
